module.exports = __webpack_public_path__ + "static/media/question.d54fd9da.svg";